export default "__VITE_ASSET__qDTy3NaC__";